module.exports = __webpack_public_path__ + "static/media/Penn frame blue.c35e872d.png";